/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../../../../components/Modal';
import { getMonth } from '../../../../utils/date';
import useForm from '../../../../hooks/useForm';
import Form from '../../../../components/Form';
import { bulkAdd } from '../../../../apis/salary/salary-history';
import { toast } from '../../../../utils/toast';
import { restoreComma } from '../../../../utils/validator/comma';

const defaultForm = {
  payFor: getMonth(undefined, -1, 'YYYY-MM'),
  payDate: getMonth(undefined, -1, 'YYYY-MM-DD'),
  exposureDate: getMonth(undefined, -1, 'YYYY-MM-DD'),

};

const SalaryCopyAdd = ({ open, setOpen, setIsLoading, selectedList, setSelectedList, submit }) => {
  const cancel = () => {
    setOpen(false);
    setIsLoading(false);
    setSelectedList && setSelectedList([]);
    submit && submit();
    reset();
  };

  const [payMonth, setPayMonth] = useState([]);
  const [fields, setFields] = useState([]);

  useEffect(() => {
    setPayMonth([
      { label: getMonth(undefined, 6, 'YYYY.MM'), value: getMonth(undefined, 6, 'YYYY-MM') },
      { label: getMonth(undefined, 5, 'YYYY.MM'), value: getMonth(undefined, 5, 'YYYY-MM') },
      { label: getMonth(undefined, 4, 'YYYY.MM'), value: getMonth(undefined, 4, 'YYYY-MM') },
      { label: getMonth(undefined, 3, 'YYYY.MM'), value: getMonth(undefined, 3, 'YYYY-MM') },
      { label: getMonth(undefined, 2, 'YYYY.MM'), value: getMonth(undefined, 2, 'YYYY-MM') },
      { label: getMonth(undefined, 1, 'YYYY.MM'), value: getMonth(undefined, 1, 'YYYY-MM') },
      { label: getMonth(undefined, 0, 'YYYY.MM'), value: getMonth(undefined, 0, 'YYYY-MM') },
      { label: getMonth(undefined, -1, 'YYYY.MM'), value: getMonth(undefined, -1, 'YYYY-MM') },
      { label: getMonth(undefined, -2, 'YYYY.MM'), value: getMonth(undefined, -2, 'YYYY-MM') },
      { label: getMonth(undefined, -3, 'YYYY.MM'), value: getMonth(undefined, -3, 'YYYY-MM') },
      { label: getMonth(undefined, -4, 'YYYY.MM'), value: getMonth(undefined, -4, 'YYYY-MM') },
      { label: getMonth(undefined, -5, 'YYYY.MM'), value: getMonth(undefined, -5, 'YYYY-MM') },
      { label: getMonth(undefined, -6, 'YYYY.MM'), value: getMonth(undefined, -6, 'YYYY-MM') },
    ]);
  }, []);

  useEffect(() => {
    const _fields = [
      {
        title: "귀속월",
        key: "payFor",
        type: 'select',
        options: { list: payMonth },
      },
      {
        title: "지급일",
        type: 'datepicker',
        key: "payDate"
      },
      {
        title: "노출일",
        type: 'datepicker',
        key: "exposureDate"
      },
    ];
    setFields(_fields);

  }, [payMonth]);
  const _submit = (_form) => {

    const salaries = selectedList.map(salay => {
      delete salay.idx;
      delete salay.index;

      return {
        ...salay,
        ...form,
        payMonth: form.payFor,
        payFor: `${form.payFor}-01`,
        payDate: form.payDate[0],
        exposureDate: form.exposureDate[0],
        allowanceList: salay?.allowanceList?.map(item => ({ ...item, value: +restoreComma(item.value) })),
        deductionList: salay?.deductionList?.map(item => ({ ...item, value: +restoreComma(item.value) })),
      };
    });

    bulkAdd({ salaries }).then(res => {
      toast.success('복사가 완료되었습니다.');
      cancel();
    }).catch((err) => console.error(err));

  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    reset,
  } = useForm(defaultForm, _submit);

  return (
    <>
      <Modal size="md" isOpen={open} close={cancel}>
        <ModalHeader>급여내역 복사하기</ModalHeader>

        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={"등록하기"}
          submit={handleSubmit}
          cancel={cancel}
        />
      </Modal>

    </>
  );
};

export default SalaryCopyAdd;